<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark">Order Report</h1>
                        <img id="logoId" src="../../../public/images/logo.png" style="width:40px; height:40px; display:none;">
                    </div><!-- /.col -->
                    <div class="col-sm-6 text-right">
                    </div>
                </div><!-- /.row -->
            </div><!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <form v-on:keyup.enter="searchOrder">
                                    <div class="row">
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="contact">Contact</label>
                                                <input type="text" id="contact" v-model="search.contact" placeholder="Name, Mobile, Address" class="form-control">
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">                                            
                                                <label for="sku">Order ID</label>
                                                <input type="text" id="sku" v-model="search.sku" placeholder="Order ID" class="form-control">
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="rider_id">Rider</label>
                                                <v-select name="rider_id"
                                                    v-model="search.rider_id"
                                                    label="text"
                                                    :reduce="item => item.id"
                                                    :options= riderList
                                                    :placeholder="$t('globalTrans.select')"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="merchant_id">Merchant</label>
                                                <v-select name="merchant_id"
                                                    v-model="search.merchant_id"
                                                    label="text"
                                                    :reduce="item => item.id"
                                                    :options= commonObj.merchantList
                                                    :placeholder="$t('globalTrans.select')"
                                                />
                                            </div>
                                        </div> 
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="merchant_id">Store</label>
                                                <v-select name="merchant_id"
                                                    v-model="search.store_id"
                                                    label="text"
                                                    :reduce="item => item.id"
                                                    :options= storeList
                                                    :placeholder="$t('globalTrans.select')"
                                                />
                                            </div>
                                        </div>  
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="kam_id">KAM</label>
                                                <v-select name="merchant_id"
                                                    v-model="search.kam_id"
                                                    label="text"
                                                    :reduce="item => item.id"
                                                    :options= kamUserList
                                                    :placeholder="$t('globalTrans.select')"
                                                />
                                            </div>
                                        </div> 
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="zonal_id">Zonal</label>
                                                <v-select name="zonal_id"
                                                    multiple
                                                    v-model="search.zonal_id"
                                                    label="text"
                                                    :reduce="item => item.id"
                                                    :options= commonObj.zonalList
                                                    :placeholder="$t('globalTrans.select')"
                                                />
                                            </div>
                                        </div> 
                                        <slot v-if="isDateAble">                                      
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label for="date_parameter_id">Date Parameter</label>
                                                    <select id="date_parameter_id" v-model="search.date_parameter_id" class="form-control">                                            
                                                        <option v-for="(item, index) in customState.dateParameterList" :value="item.id" :key="index">{{ item.text }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label for="date_type_id">Date</label>
                                                    <select id="date_parameter_id" v-model="search.date_type_id" class="form-control">  
                                                        <option v-for="(item, index) in customState.dateTypeList" :value="item.id" :key="index">{{ item.text }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label for="start_date">Start Date</label>
                                                    <input type="date" id="start_date" v-model="search.start_date" class="form-control">                                                
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label for="end_date">End Date</label>
                                                    <input type="date" id="end_date" v-model="search.end_date" class="form-control">                                                
                                                </div>
                                            </div>
                                        </slot>
                                        <!-- <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="source_hub_id">Source Hub</label>
                                                <v-select name="source_hub_id"
                                                    v-model="search.source_hub_id"
                                                    label="text"
                                                    :reduce="item => item.id"
                                                    :options= commonObj.hubList
                                                    :placeholder="$t('globalTrans.select')"
                                                />
                                            </div>
                                        </div> -->
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label for="destination_hub_id">Destination Hub</label>
                                                <v-select name="destination_hub_id"
                                                    multiple
                                                    v-model="search.destination_hub_id"
                                                    label="text"
                                                    :reduce="item => item.id"
                                                    :options= commonObj.hubList
                                                    :placeholder="$t('globalTrans.select')"
                                                />
                                            </div>
                                        </div>
                                    </div>                                    
                                    <div class="row">
                                        <div class="col-md-1">
                                            <div class="form-group">
                                                <label for="payment_status">Payment</label>
                                                <select id="payment_status" v-model="search.payment_status" class="form-control">                                            
                                                    <option :value="4">Select</option>
                                                    <option :value="1">Due</option>
                                                    <option :value="0">Unpaid</option>
                                                    <option :value="3">Paid </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-1">
                                            <div class="form-group">
                                                <label for="collection">Collection</label>
                                                <select id="collection" v-model="search.collection" class="form-control">                                            
                                                    <option :value="0">Select</option>
                                                    <option :value="1">From Rider</option>
                                                    <option :value="2">From Hub</option>
                                                    <option :value="3">Final Collection</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <label for="status">Status</label>
                                                <slot>
                                                    <div class="icheck-success d-inline ml-2">
                                                        <input type="radio" name="head_status" v-model="search.head_status" value="0" checked="" id="radioSuccess0">
                                                        <label for="radioSuccess0">All</label>
                                                    </div>
                                                    <div class="icheck-success d-inline ml-2">
                                                        <input type="radio" name="head_status" v-model="search.head_status" value="1" checked="" id="radioSuccess1">
                                                        <label for="radioSuccess1">Completed</label>
                                                    </div>
                                                    <div class="icheck-success d-inline ml-2">
                                                        <input type="radio" name="head_status" v-model="search.head_status" value="2" id="radioSuccess2">
                                                        <label for="radioSuccess2">Incompleted</label>
                                                    </div>
                                                    <div class="icheck-success d-inline ml-2">
                                                        <input type="radio" name="head_status" v-model="search.head_status" value="3" id="radioSuccess3">
                                                        <label for="radioSuccess3">Returnable</label>
                                                    </div>
                                                </slot>  
                                                <v-select name="status"
                                                    multiple
                                                    v-model="search.status"
                                                    label="text"
                                                    :reduce="item => item.id"
                                                    :options= userStatusList
                                                    :placeholder="$t('globalTrans.select')"
                                                />   
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group" style="margin-bottom:0px;">
                                            <label>
                                                <input type="checkbox" @click="selectAll" v-model="allSelected">
                                                <p style="display: inline-block; margin-left: 4px; font-size: 15px;">Select All | Selected ({{ totalSelected }} / {{ totalOrder }}) </p>
                                            </label>
                                            <button class="btn btn-info btn-sm ml-2 mr-2" type="submit" @click="showActionPanelModal"><i class="fa fa-check"></i> Take Action</button>
                                            <button class="btn btn-info btn-sm mr-2" type="submit" @click.prevent="searchOrder"><i class="fa fa-search"></i> Filter</button>                                              
                                            <button class="btn btn-warning btn-sm" @click.prevent="reload"><i class="fa fa-sync-alt"></i></button>
                                             <slot v-if="loading">
                                                <div class="ml-1 spinner-border spinner-border-sm text-success" role="status"></div>
                                            </slot>
                                            <button v-else style="margin-left:10px" class="btn btn-success btn-sm" type="button" @click.prevent="excelDownload">
                                                <i class="fa fa-download"></i> Excel
                                            </button> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-header">
                                <OrderReportSummary :search="search"></OrderReportSummary>
                            </div>
                            
                            <div class="card-body">                                
                                <div class="table-responsive order-table-container">
                                    <table id="orderTable" class="table table-bordered table-sm" style="width:100%">
                                        <thead>
                                            <tr class="text-center">
                                                <th style="width:8%">Order ID</th>
                                                <th style="width:10%">Merchant</th>
                                                <th style="width:8%">Customer</th>
                                                <th style="width:11%">Address</th>
                                                <th style="width:6%">Status</th>  
                                                <th style="width:6%">Source to Destination</th>
                                                <th style="width:6%">Order Date</th>
                                                <th style="width:9%">Instruction</th>
                                                <th style="width:3%">Price</th>
                                                <th style="width:3%">Collected</th>
                                                <th style="width:4%">Payment</th>      
                                                <th style="width:5%">Rider</th>     
                                                <th style="width:2%">OTP</th>     
                                                <th style="width:5%">Age (days) & Attempt</th>     
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(order,key) in orders" :key="key" :class="((parseFloat(order.amount) >= parseFloat(order.collected)) && (order.amount_receive > 0)) ? 'text-red' : 'text-black'">
                                                <td style="width:8%" :class="order.urgent == 1 ? 'text-red' : 'text-black'" :title="order.urgent == 1 ? 'Urgent' : ''"  class="order-id">
                                                    <label>
                                                        <input v-if="isSelected" v-model="ordersData" @click="singleSelect(order)" :value="order" type="checkbox" class="order-checkbox" />
                                                        <p>{{ order.id }}</p>
                                                    </label>
                                                </td>
                                                <td style="width:10%" @click="orderLog(order.logs)">{{ order.merchant.business }} {{ order.store ? '('+ order.store.name +')' : '' }}</td>
                                                <td style="width:8%">{{ order.name }}, {{ order.mobile }}{{ order.mobile_2 ? ', '+ order.mobile_2 : '' }}</td>
                                                <td style="width:11%">{{ order.address }}</td>
                                                <td style="width:6%" class="text-center">
                                                    <span :class="'status-'+order.status">{{ getStatus(order.status) }} </span> <br/>
                                                     {{order.status_time | dateformat }}, {{order.status_time | timeformat }}<br>
                                                </td>                                    
                                                <td style="width:6%" class="text-center">{{ order.source ? order.source.name : '' }} to {{ order.destination ? order.destination.name : '' }}</td>
                                                <td style="width:6%">{{ order.date }}</td>
                                                <td style="width:9%">{{ order.instruction }}</td>
                                                <td style="width:3%" class="text-center">{{ order.price }}</td>
                                                <td style="width:3%" class="text-center">{{ order.collected }}</td>                                         
                                                <td style="width:4%" class="text-center"><span :class="'payment-status-'+order.payment_status">{{ order.payment_status != 0 ? getPaymentStatus(order.payment_status, order.payment_id) : '' }}</span></td>         
                                                <td style="width:5%">
                                                    <span v-if="order.rider">{{ order.rider.name }} <br/>{{ order.rider.mobile}}</span>
                                                </td>
                                                <td style="width:2%">{{ order.otp }}</td>                           
                                                <td style="width:5%" class="text-center">
                                                    {{ order.age }} & {{ order.attempt }} <br/>
                                                    {{ getOldAndNewId(order) }}
                                                </td>     
                                            </tr>
                                            <infineLoading v-if="spinner" @distance="1" @infinite="loadData"></infineLoading>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>
        <div v-if="orderLogModal" class="modal fade show" style="display:block" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-info text-white">
                        <h5 class="modal-title text-center w-100">Order Log</h5>
                        <button type="button" class="close" aria-label="Close" @click="cancelModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table table-bordered table-sm">
                            <tr>
                                <th style="width:20%">Action By</th>
                                <th style="width:55%">Action</th>
                                <th style="width:25%">Date & Time</th>
                            </tr>
                            <tr v-for="(log, index) in logs" :key="index">
                                <td>{{ log.operation_by }}</td>
                                <td>{{ log.operation }}</td>
                                <td>{{ log.created_at | dateformat }} at {{ log.created_at | timeformat }}</td>
                            </tr>
                        </table>                      
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-danger" @click="cancelModal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import statusHelper from '@/utils/statusMapping'
    import infineLoading from 'vue-infinite-loading'
    import config from '@/config'
    import OrderReportSummary from '@/components/report/OrderReportSummary.vue'
    import moment from 'moment'
    export default {
        name:'Order',
        components: {
            infineLoading: infineLoading,
            OrderReportSummary: OrderReportSummary
        },
        data () {
            return {
                exchangeList: [
                    { id: 1, text: 'Yes' },
                    { id: 2, text: 'NO' },
                ],
                isExcelDownload: false,
                summary: null,
                spinner: true,
                loader: true, 
                loading: false,
                isScan: false,
                isSelected: true,
                selected: [],
                allSelected: false,
                ordersData: [],
                zones:[],
                orders:[],
                totalOrder: 0,
                order_id: '',
                printorders:[],
                barcode:{
                    sku: ''
                },
                orderList: [],
                page: 1,
                search: {
                    isSearch : 0,
                    contact : '',
                    sku : '',
                    ref_id: '',
                    merchant_id : '',
                    store_id : '',
                    deposit_id : '',
                    rider_id    : '',
                    coverage_area_id : '',
                    division_id : '',
                    district_id : '',
                    thana_id : '',
                    area_id : '',
                    payment_status : 4,
                    collection : 0,
                    head_status : '',
                    status : '',
                    date_parameter_id : 2,
                    date_type_id : 2,
                    source_hub_id : '',
                    destination_hub_id : '',
                    kam_id: '',
                    zonal_id: '',
                    start_date : moment().subtract(1,'d').format('YYYY-MM-DD'),
                    end_date : moment().format('YYYY-MM-DD')
                },
                form_edit:'',
                errors:[],
                createModal: 0,
                issueModal: 0,
                issue: '',
                deleteModal:false,
                actionPanelModal:false,
                bulk:{
                    order_ids: [],
                    status: '',
                    merchant_id: '',
                    rider_id: '',
                    hub_id: '',
                    payment_status: 1
                },
                status:{
                    key: '',
                    sku: '',
                    status: '',
                    collected: 0,
                    reason:' ',
                    reason_id: 0,
                },
                isRescheduleDate: false,
                isReason: false,
                isReasonText: false,
                areaList: [],
                districtList: [],
                thanaList: [],
                totalSelected: 0,
                takeAction: true,
                key:'',
                mappingStatusList: [],
                takeActionStatusList: [],
                isDeadlineReadonly: false,
                kamUserList: [],
                storeList: [],
                orderLogModal:false,
                logs:[]
            }
        },
        watch: {
            stateReload: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.searchOrder()
                }
            },
            'search.date_type_id': function (newVal, oldVal) {
                if (newVal != oldVal) {
                   this.dateTypeChange(newVal)
                }
            },
            'search.head_status': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.search.status = this.getCustomSearchStatus(newVal)
                }
            },
            'search.coverage_area_id': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.areaList = this.getAreaByCoverageAreaList(newVal)
                }
            },
            'search.division_id': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.districtList = this.getDistrictList(newVal)
                }
            },
            'search.district_id': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.thanaList = this.getThanaList(newVal)
                }
            },
            'search.merchant_id': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.storeList = this.getStoreList(newVal)
                }
            },
            'form_edit.division_id': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.districtList = this.getDistrictList(newVal)
                }
            },
            'form_edit.district_id': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.thanaList = this.getThanaList(newVal)
                }
            },
            'search.destination_hub_id': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.areaList = this.getHubAreaList(newVal)
                }
            }
        },
        created () {
            this.loadKamUser();
            if (this.$route.query) {
                Object.assign(this.search, this.$route.query)
            } 
            // this.loadSummary();
            this.searchOrder();
        },
        computed : {
            stateReload () {
                return this.$store.state.stateReload
            },
            customState () {
                return this.$store.state
            },
            userStatusList () {
                return this.$store.state.userStatusList
            },
            authUser () {
                return this.$store.state.authUser
            },
            commonObj () {
                return this.$store.state.commonObj
            },
            isDateAble () {
                return (this.authUser.role_id != 5 && this.authUser.role_id != 6) ? true : false 
            },
            riderList () {
                if (this.authUser.role_id == 7) {
                    return this.commonObj.riderList.filter(el => el.hub_id == this.authUser.hub_id)
                } else {
                    return this.commonObj.riderList
                }
            }
        },
        methods:{
            dateTypeChange (newVal) {
                const dateTypeId = newVal
                if (dateTypeId == 1) {
                    this.search.start_date = this.search.end_date = moment().format('YYYY-MM-DD')
                } else if (dateTypeId == 2) {
                    this.search.start_date = this.search.end_date = moment().subtract(1,'d').format('YYYY-MM-DD')
                } else if (dateTypeId == 3) {
                    this.search.start_date = moment().subtract(31,'d').format('YYYY-MM-DD')
                    this.search.end_date = moment().format('YYYY-MM-DD')
                } else if (dateTypeId == 4) {
                    this.search.start_date = moment().subtract(180,'d').format('YYYY-MM-DD')
                    this.search.end_date = moment().format('YYYY-MM-DD')
                } else if (dateTypeId == 5) {
                    this.search.start_date = moment().subtract(365,'d').format('YYYY-MM-DD')
                    this.search.end_date = moment().format('YYYY-MM-DD')
                }
            },
            reload () {
                this.commonStatus = []
                this.search = Object.assign({}, {
                    isSearch    : 0,
                    contact     : '',
                    sku         : '',
                    ref_id: '',
                    merchant_id : '',
                    deposit_id : '',
                    rider_id    : '',
                    coverage_area_id : '',
                    division_id : '',
                    district_id : '',
                    thana_id : '',
                    area_id     : '',
                    payment_status : 4,
                    collection : 0,
                    head_status : '',
                    status      : '',
                    date_parameter_id  : 2,
                    date_type_id  : 2,
                    source_hub_id  : '',
                    destination_hub_id  : this.authUser.role_id == 7 ? this.authUser.hub_id : '',
                    start_date : moment().subtract(1,'d').format('YYYY-MM-DD'),
                    end_date : moment().format('YYYY-MM-DD')
                })
                this.orderList = this.ordersData = this.printorders = []
                this.totalSelected = 0
            },
            selectAll: function() {   
                this.takeAction = false                
                this.ordersData = [];
                this.orderList = [];
                if (!this.allSelected) {
                    for (var order in this.orders) {
                        this.ordersData.push(this.orders[order])
                        this.orderList.push(this.orders[order].id);
                    }
                    this.totalSelected = this.orderList.length
                } else {
                    this.totalSelected = 0
                }
            },
            singleSelect(order) {
                this.takeAction = false
                if (!this.orderList.includes(order.id)) {
                    this.orderList.push(order.id)
                } else {
                    this.orderList.splice(this.orderList.indexOf(order.id), 1)
                }     
                this.totalSelected = this.orderList.length          
                this.allSelected = false;                
            },
            getOldAndNewId (order) {
                if(order.pathao_id) {
                    return 'Old Id: '+ order.pathao_id;
                } else if (order?.details?.new_id) {
                    return 'New Id: '+ order.details.new_id;
                }
                return '';
            },
            getBase64Logo (logo) {
                var canvas = document.createElement('canvas')
                canvas.width = logo.width
                canvas.height = logo.height
                var ctx = canvas.getContext('2d')
                ctx.drawImage(logo, 0, 0)
                var dataURL = canvas.toDataURL('image/png')
                return dataURL.replace(/^data:image\/(png|jpg);base64,/, '')
            },
            getStatus (status) {
                const tmpStatus = this.customState.statusList.find(tmp => tmp.id == status)
                return typeof tmpStatus != 'undefined' ? tmpStatus.text : status
            },
            getPaymentStatus (paymentStatus, paymentId) {
                if (paymentStatus == 1) {
                    return 'Due'
                } else if (paymentStatus == 2) {
                    return 'Processing'
                } else if (paymentStatus == 3) {
                    return 'Paid ID : '+ paymentId 
                }
            },
            getCustomSearchStatus (headStatus) {
                let searchAbleStatusList = []
                if (headStatus == 1) {
                    searchAbleStatusList = [14,15,16,19,20]
                } else if (headStatus == 2) {
                    searchAbleStatusList = [3,4,5,6,7,10,11,12,13,17,18,30,37,38]
                } else if (headStatus == 3) {
                    searchAbleStatusList = [21,22,23,24,25,26]
                } else if (headStatus == 0) {
                    searchAbleStatusList = []
                }
                return searchAbleStatusList
            },
            searchOrder() {
                this.search.isSearch = 1
                this.totalOrder = 0
                this.orders = []
                this.page = 1
                this.search.destination_hub_id = this.authUser.role_id == 7 ? this.authUser.hub_id : this.search.destination_hub_id
                if (this.search.status.length == 1 ) {
                    this.mappingStatusList = statusHelper.getMappingStatus(this.search.status[0])
                } else {
                    this.mappingStatusList = statusHelper.getMappingStatus(0)
                }
                // this.loadSummary()
                this.loadData()
            },
            async loadSummary() {
                this.loading = true
                const params = this.authUser.role_id == 7 ? Object.assign({}, this.search, { destination_hub_id: this.authUser.hub_id }) : this.search 
                const response = await config.getData('report/order-report-summary', params)
                this.loading = false
                if (response.success) {
                    this.summary = response.summary
                } else {
                    this.summary = null
                }
            },
            loadData($state) {
                this.$store.dispatch('summarySearch', true)
                this.loader = false
                let vm = this;
                if (this.$route.query.query_status) {
                    this.search = Object.assign(this.search, { query_status: this.$route.query.query_status})
                }
                const params = Object.assign({}, this.search, { role_id: this.authUser.role_id, page: this.page })
                config.getData('report/order-report-details', params)
                .then(res => {
                    return res
                }).then(response => {
                    // this.summary = response.summary
                    this.totalOrder += response.data.data.length
                    response.data.data.map(item => {
                        const tmpItem = this.getRelationalData(item)
                        vm.orders.push(tmpItem)
                    })
                    if (this.totalOrder < response.data.total) {
                        this.spinner = true
                        $state.loaded()
                    } else {
                        this.spinner = false
                    }
                });
                
                this.page = this.page + 1;
            },
            getRelationalData (item) {
                const start = new Date(item.date);
                const end   = new Date(item.activity_date);
                const time  = end.getTime() - start.getTime();
                const newAge= Math.ceil(time / (1000 * 3600 * 24));
                return Object.assign(item, {
                    age: newAge
                })
            },
            changeWeight(weightChargeId){
                const tmpCharge = this.commonObj.weightChargeList.find(charge => charge.id == weightChargeId)
                this.form_edit.weight_charge = tmpCharge.charge
            },
            checkIsDeadlineReadOnly (orderDetails) {
                return (orderDetails.status != 3 && orderDetails.status != 4 && this.authUser.role_id != 1) ? true : false
            },
            cancelModal(){                
                this.actionPanelModal = false
                this.isReasonText = this.isRescheduleDate = this.isScan = this.isExcelDownload = this.orderLogModal = false
                this.allSelected = false
                this.barcode.sku = ''
                this.totalSelected = 0
                this.printorders = []
                this.ordersData = []
                this.orderList = []   
                this.mappingStatusList = []   
                this.takeActionStatusList = []   
                this.bulk.rider_id = this.bulk.status = this.bulk.merchant_id = this.bulk.hub_id = ''
                this.bulk.payment_status = 1
            },
            showActionPanelModal () {
                this.isScan = true
                this.actionPanelModal = true
                this.bulk.merchant_id = this.search.merchant_id
                this.takeActionStatusList = this.search.status ? statusHelper.getTakeActionStatus(this.search.status) : ''
                document.body.classList.add("modal-open");
            },
            async loadKamUser () {
                const response = await config.getData('/user/all')                        
                if (response.status === 200) {                                           
                    this.kamUserList = response.data;
                } else {
                    this.kamUserList = []
                }
            },
            removeRow(index){
                this.isScan = true
                this.orderList.splice(index, 1)
            },
            getDistrictList (divisionId) {
                return this.commonObj.districtList.filter(el => el.division_id == divisionId)
            },
            getThanaList (districtId) {
                return this.commonObj.thanaList.filter(el => el.district_id == districtId)
            },
            getStoreList (merchantId) {
                return this.commonObj.storeList.filter(el => el.merchant_id == merchantId)
            },
            getAreaByCoverageAreaList (coverageAreaId) {
                return this.commonObj.areaList.filter(el => el.coverage_area_id == coverageAreaId)
            },
            getHubAreaList (hubId) {
                return this.commonObj.areaList.filter(el => el.hub_id == hubId)
            },
            checkCollectedAmount () {
                this.isReasonText = (parseFloat(this.form_edit.price) != parseFloat(this.form_edit.collected) || this.form_edit.status == 19) ? true : false                
            },
            async excelDownload () {
                this.loading = true
                try {
                    const params = Object.assign({}, this.search, {
                        status: Array.isArray(this.search.status) ? this.search.status.join(',') : this.search.status
                    })
                    const response = await config.getFile('excel-download/order-report', params)
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'OrderReport.csv')
                    document.body.appendChild(link)
                    link.click()
                    link.remove()
                    window.URL.revokeObjectURL(url)
                } catch (error) {
                    this.$toast.error({
                        title: 'Error',
                        message: 'Sorry, something went wrong',
                        color: '#dc3545'
                    })
                }
                this.loading = false
            },
            isDeleteVisible(order) {
                return (this.authUser.role_id <= 3 && order.status < 7) || this.authUser.role_id == 9;
            },
            orderLog (logs) {
                this.orderLogModal = true
                this.logs = logs
            }
        }
    }
</script>
<style scoped>
    @media print{
        body {
            margin-left:-10px;
        }
    }
    .mt-30 {
        margin-top: 30px !important;
    }
</style>